import { Image } from "grommet";

const WRTCLogoPlain = ({ height = "30px" }: { height?: string }) => (
  <Image
    height={height}
    a11yTitle="Wildfire Risk to Communities logo"
    src={process.env.PUBLIC_URL + "/logo-wrtc-plain.png"}
  />
);

export default WRTCLogoPlain;
